import { Component, ViewChild, OnInit, Injectable, Input } from "@angular/core";
import { DataSource } from "@angular/cdk/collections";
import { MdPaginator } from "@angular/material";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/startWith";
import "rxjs/add/observable/merge";
import "rxjs/add/operator/map";
import { AuthService } from "../../../../../services/auth.service";
import { ComponentInterface } from "../../models/component.interface";
import { DocumentModel } from "../../../../../models/documents/document.model";
import { DashboardService } from "../../../../../services/dashboard.service";

import { saveAs } from "file-saver";
import { ExternalSourceDocumentModel } from "../../../../../models/dashboard/externalSourceDocument.model";
import { DriverModel } from "../../../../../models/dashboard/driver.model";

@Component({
  selector: "app-documents-external-source",
  templateUrl: "./documentsExternalSource.component.html",
  styleUrls: ["./documentsExternalSource.component.css"],
})
export class DocumentsExternalSourceComponent
  implements OnInit, ComponentInterface {
  @Input() config;

  displayedColumns = ["name", "dataUpload", "download"];
  // displayedColumns = ["name", "link", "dataUpload", "download"];
  dataSource: DocumentsDataSource = null;
  isLoading: boolean = false;
  rowCount: number = 0;
  data: DocumentModel[] = null;
  downloads: DocumentModel[] = null;
  title: string;
  subtitle: string;
  downloadDriver: DriverModel;

  countIncassiDaRendicontare: number;

  constructor(
    private _dashboardService: DashboardService,
    public _authService: AuthService
  ) {
    //this.dataSource = new IncassiInLavorazioneDataSource(this._incassiService, this.paginator);
  }
  dictionary: any = {
    token: "token",
    idBloccoDownloadExternalSourceItem: "idBloccoDownloadExternalSourceItem",
  };

  @ViewChild(MdPaginator) paginator: MdPaginator;

  ngOnInit() {
    this.isLoading = true;
    this._dashboardService
      .getBloccoSlider(this.config.token)
      .subscribe((blocco) => {
        this.title = blocco.titolo;
        this.subtitle = blocco.sottotitolo;

        const verbo = blocco.externalSourceDriver.routeAnagrafica.verbo;
        const rotta = blocco.externalSourceDriver.routeAnagrafica.rotta;
        const json = blocco.externalSourceDriver.routeAnagrafica.json;
        // this._dashboardService
        //   .getExternalSourceItems(rotta, {
        //     ...json,
        //     idBloccoDownloadExternalSource: blocco.idBlocco,
        //   })
        //   .subscribe((res) => console.log(res));
        // const body = {
        //   idBloccoDownloadExternalSource: blocco.id,
        // };
        let body = {};
        // body from json
        // /*
        const Json = JSON.parse(json);
        const keys = Object.keys(Json);
        keys.forEach((key) => {
          if (Json[key]) {
            if (Json[key].startsWith("@@")) {
              body = { ...body, [key]: blocco[this.dictionary[key]] };
            } else {
              body = { ...body, [key]: Json[key] };
            }
          }
        });
        console.log(body);
        if (verbo === "POST") {
          this._dashboardService
            .postExternalSourceItems(rotta, body)
            .subscribe((res) => {
              this.dataSource = new DocumentsDataSource(res, this.paginator);
              this.rowCount = res.length;
              this.downloads = res;
              this.isLoading = false;
            });
        } else {
          this._dashboardService
            .getExternalSourceItems(rotta)
            .subscribe((res) => {
              this.dataSource = new DocumentsDataSource(res, this.paginator);
              this.rowCount = res.length;
              this.downloads = res;
              this.isLoading = false;
            });
        }
        // this._dashboardService.getItems(body).subscribe((res) => {
        //   console.log(res);
        //   this.dataSource = new DocumentsDataSource(res, this.paginator);
        //   this.rowCount = res.length;
        //   this.downloads = res;
        //   this.isLoading = false;
        // });

        this._dashboardService
          .getBlocchiDownloadExternalSourceDriver()
          .subscribe((response) => {
            this.downloadDriver = response.find(
              (driver) =>
                driver.routeAnagrafica.nome ===
                "BloccoDownloadExternalSourceItemDownload"
            );
          });
      });
  }

  downloadFile(item) {
    const matches = this.downloadDriver.routeAnagrafica.rotta.match(
      /@@(.*?)@@/gm
    );
    let rotta = this.downloadDriver.routeAnagrafica.rotta;
    if (matches) {
      matches.forEach((match) => {
        rotta = this.downloadDriver.routeAnagrafica.rotta.replace(
          match,
          item[this.dictionary[match.replace(/@/g, "")]]
        );
      });
    }
    this._dashboardService
      .downloadExternalSourceFileDriver(rotta)
      .subscribe((file) => {
        saveAs(file, item.documento);
      });
  }
}

export class DocumentsDataSource extends DataSource<any> {
  constructor(
    //private _incassiService: IncassiService,
    private data: ExternalSourceDocumentModel[],
    private _paginator: MdPaginator
  ) {
    super();
  }

  connect(): Observable<ExternalSourceDocumentModel[]> {
    return Observable.of(this.data);
  }

  disconnect() {}
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/documentsExternalSource/documentsExternalSource.component.ts